<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">汇好看直播电商</div>
          <div class="line" />
          <div class="desc">
            企业私域电商直播平台
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <div
                class="btn1"
                @click="openLoginModal"
              >免费试用</div>
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      <div class="improve" style="height:716px;">
          <div class="content1">
  
          </div>
      </div>
      <div class="improve1 " style="height:643px;">
          <div class="sk-block-title1">
              <div class="title1">获客成本高，平台没人气，观众没互动？</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve" style="height:666px;">
          <div class="sk-block-title1">
              <div class="title1">路人粉留不住，会员流失率高，没有留存和复购？</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
  
          </div>
      </div>
      
      <div class="improve1 " style="height:664px;">
          <div class="sk-block-title1">
              <div class="title1">使用第三方直播工具，数据不能打通溯源，分析深度广度有限？</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
  
          </div>
      </div>
      <div class="improve" style="height:658px;">
          <div class="sk-block-title1">
              <div class="title1">主播费用高、人效低，光有工具没人播？</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">
  
          </div>
      </div>
      
      <div class="improve1 " style="height:554px;">
          <div class="sk-block-title1">
              <div class="title1">直播电商产品矩阵</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">
  
          </div>
      </div>
      
      <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcLiveBroadcast/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcLiveBroadcast/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
      <Contact :infoSources="'汇通数科官网-汇好看直播'"/>
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
      <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'9'"
        />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";
  import LoginModal from '@/components/LoginModal'

  export default {
    metaInfo: metaInfo.QcLiveBroadcast,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    LoginModal
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
      };
    },
    mounted() {},
    methods: {
        // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .programme{
        height:1047px;
        background: #F4F5FB;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:49px;
          width: 1200px;
          height:834px;
          background: url("~@/assets/images/QcMarketing/content9.png") no-repeat;
          background-size: 1200px 834px;
      }
  }
  .improve1{
    background: #F8FBFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:42px;
          width: 1200px;
          height:456px;
          background: url("~@/assets/images/QcLiveBroadcast/content2.png") no-repeat;
          background-size: 1200px 456px;
      }
      .content2{
          margin-top:39px;
          width: 1200px;
          height:467px;
          background: url("~@/assets/images/QcLiveBroadcast/content4.png") no-repeat;
          background-size: 1200px 467px;
      }
      .content3{
          margin-top:60px;
          width: 1200px;
          height:341px;
          background: url("~@/assets/images/QcLiveBroadcast/content6.png") no-repeat;
          background-size: 1200px 341px;
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
    background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:50px;
          width: 1200px;
          height:614px;
          background: url("~@/assets/images/QcLiveBroadcast/content1.png") no-repeat center;
          background-size: 1200px 614px;
      }
      .content2{
          margin-top:41px;
          width: 1200px;
          height:466px;
          background: url("~@/assets/images/QcLiveBroadcast/content3.png") no-repeat center;
          background-size: 1200px 466px;
      }
      .content3{
          margin-top:60px;
          width: 1200px;
          height:455px;
          background: url("~@/assets/images/QcLiveBroadcast/content5.png") no-repeat center;
          background-size: 1200px 455px;
      }
  }
  
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcLiveBroadcast/banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
            width: 484px;
            height: 84px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  